(function() { window.GUID_24deb3fa_3a58_4ee4_bd20_cfdeb7841e89 = { getGuid: function() { return "24deb3fa-3a58-4ee4-bd20-cfdeb7841e89"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class PromotionPopup extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.version = params[1];
            }
            OnBindEvents() { }
            OnControlRendered() {
                if (this.version) {
                    const utcNow = new Date().toUTCString();
                    const dimensionValue = `${this.version} - ${utcNow}`;
                    console.log(`Setting dimension "playerFeaturePromoted" to "${dimensionValue}"...`);
                    CS.Analytics.Event("Promo", "playerFeaturePromoted", dimensionValue);
                }
            }
            OnDispose() { }
        }
        Controls.PromotionPopup = PromotionPopup;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=promotion-popup.js.map
